module.exports = {
	"id": "DE",
	"name": "Germany",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.026196,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.013098,
			"19": null,
			"20": null,
			"21": 0.006549,
			"22": 0.045843,
			"23": null,
			"24": 0.013098,
			"25": null,
			"26": 0.019647,
			"27": null,
			"28": 0.006549,
			"29": 0.026196,
			"30": null,
			"31": 0.032745,
			"32": 0.006549,
			"33": 0.032745,
			"34": 0.026196,
			"35": 0.019647,
			"36": 0.013098,
			"37": 0.235764,
			"38": 0.026196,
			"39": 0.052392,
			"40": 0.045843,
			"41": 0.072039,
			"42": 0.052392,
			"43": 0.203019,
			"44": 0.039294,
			"45": 0.058941,
			"46": 0.052392,
			"47": 0.058941,
			"48": 0.13098,
			"49": 0.903762,
			"50": 0.183372,
			"51": 0.766233,
			"52": 0.648351,
			"53": 14.558427,
			"54": 3.86391,
			"55": 0.06549,
			"56": 0.013098,
			"57": null
		},
		"firefox": {
			"2": 0.006549,
			"3": 0.013098,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.013098,
			"11": 0.006549,
			"12": 0.026196,
			"13": 0.013098,
			"14": null,
			"15": 0.006549,
			"16": 0.026196,
			"17": 0.006549,
			"18": 0.006549,
			"19": null,
			"20": 0.013098,
			"21": 0.006549,
			"22": 0.013098,
			"23": 0.006549,
			"24": 0.045843,
			"25": 0.006549,
			"26": 0.019647,
			"27": 0.013098,
			"28": 0.026196,
			"29": 0.019647,
			"30": 0.026196,
			"31": 0.045843,
			"32": 0.019647,
			"33": 0.045843,
			"34": 0.045843,
			"35": 0.052392,
			"36": 0.052392,
			"37": 0.045843,
			"38": 0.700743,
			"39": 0.124431,
			"40": 0.117882,
			"41": 0.13098,
			"42": 0.288156,
			"43": 0.288156,
			"44": 0.137529,
			"45": 0.772782,
			"46": 0.216117,
			"47": 1.578309,
			"48": 1.283604,
			"49": 16.968459,
			"50": 0.229215,
			"51": 0.019647,
			"52": 0.006549,
			"3.5": 0.006549,
			"3.6": 0.045843
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.013098,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.013098,
			"29": null,
			"30": 0.006549,
			"31": null,
			"32": 0.006549,
			"33": 0.006549,
			"34": 0.006549,
			"35": 0.006549,
			"36": 0.058941,
			"37": 0.045843,
			"38": 0.091686,
			"39": 0.072039,
			"40": 1.093683,
			"41": 0.176823,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006549,
			"12.1": 0.19647
		},
		"safari": {
			"0": null,
			"4": 0.026196,
			"5": 0.058941,
			"6": 0.013098,
			"7": 0.039294,
			"8": 0.189921,
			"9": 0.26196,
			"10": 1.918857,
			"3.1": null,
			"3.2": null,
			"5.1": 0.150627,
			"6.1": 0.091686,
			"7.1": 0.013098,
			"9.1": 1.218114
		},
		"ios_saf": {
			"8": 0,
			"10": 6.75448526228,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.182025562032,
			"8.1-8.4": 0.336284512906,
			"9.0-9.2": 0.160429308909,
			"9.3": 2.44757535387
		},
		"android": {
			"3": 0,
			"4": 0.0348209302326,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00435261627907,
			"4.1": 0.125604069767,
			"4.2-4.3": 0.314010174419,
			"4.4": 0.720047093023,
			"4.4.3-4.4.4": 0.726265116279
		},
		"ie": {
			"6": 0.0329955994898,
			"7": 0.0197973596939,
			"8": 0.270563915816,
			"9": 0.263964795918,
			"10": 0.230969196429,
			"11": 6.94227413265,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0199853745888,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000555149294132
		},
		"edge": {
			"12": 0.124431,
			"13": 0.772782,
			"14": 2.16117
		},
		"ie_mob": {
			"10": 0.111566197183,
			"11": 0.454233802817
		},
		"bb": {
			"7": 0.0129375,
			"10": null
		},
		"samsung": {
			"0": 5.89605
		},
		"and_uc": {
			"0": 0.45885
		},
		"op_mini": {
			"0": 0.269259476117
		},
		"and_chr": {
			"0": 16.125744
		},
		"and_ff": {
			"0": 0.07935
		}
	},
	"total": 97.6987935
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/DE.json
 ** module id = 506
 ** module chunks = 0
 **/